import { render, staticRenderFns } from "./withdraw-data.vue?vue&type=template&id=4901bb3a&scoped=true&"
import script from "./withdraw-data.vue?vue&type=script&lang=js&"
export * from "./withdraw-data.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-data.vue?vue&type=style&index=0&id=4901bb3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901bb3a",
  null
  
)

export default component.exports